// Compact reference for the keyboard-driven map shortcuts. Opened from the
// bottom-left help cluster. Pure presentation (no state, no map effects).

const BACKDROP = {
  position: 'fixed',
  inset: 0,
  zIndex: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(2,6,23,0.55)',
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  direction: 'rtl',
};
const CARD = {
  width: 'min(440px, 92vw)',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '18px 20px',
  background: 'linear-gradient(135deg, rgba(15,23,42,0.97) 0%, rgba(30,41,59,0.95) 100%)',
  borderRadius: 14,
  border: '1px solid rgba(148,163,184,0.26)',
  borderTop: '3px solid #38bdf8',
  boxShadow:
    '0 1px 0 rgba(255,255,255,0.07) inset, 0 18px 40px rgba(2,6,23,0.7)',
  color: '#e2e8f0',
  fontFamily: "'Vazirmatn', sans-serif",
};

function KeyChip({ children }) {
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 9px',
        fontSize: 11.5,
        fontWeight: 700,
        color: '#e2e8f0',
        background: 'rgba(2,6,23,0.7)',
        border: '1px solid rgba(148,163,184,0.4)',
        borderBottom: '2px solid rgba(148,163,184,0.55)',
        borderRadius: 5,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
        lineHeight: 1.4,
        direction: 'ltr',
      }}
    >
      {children}
    </span>
  );
}

function Row({ keys, label, hint }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: '10px 12px',
        background: 'rgba(2,6,23,0.4)',
        border: '1px solid rgba(148,163,184,0.18)',
        borderRadius: 8,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{
          color: '#e2e8f0', fontSize: 13, fontWeight: 700, flexShrink: 0,
        }}>{label}</span>
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 4, marginInlineStart: 'auto',
        }}>
          {keys.map((k, i) => (
            <span key={k + i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              {i > 0 && <span style={{ color: '#64748b', fontSize: 11 }}>+</span>}
              <KeyChip>{k}</KeyChip>
            </span>
          ))}
        </span>
      </div>
      {hint && (
        <div style={{ fontSize: 11.5, color: '#94a3b8', lineHeight: 1.55 }}>{hint}</div>
      )}
    </div>
  );
}

const SHORTCUTS = [
  {
    keys: ['Ctrl', 'درگ'],
    label: 'چرخشِ نقشه',
    hint: 'Ctrl را نگه دارید و ماوس را روی نقشه بکشید تا نقشه حول مرکز بچرخد.',
  },
  {
    keys: ['Ctrl', 'اسکرول'],
    label: 'تغییرِ زاویه‌ی دید',
    hint: 'Ctrl را نگه دارید و چرخِ ماوس را بچرخانید تا نمای ۳ بعدی (شیب دوربین) تغییر کند.',
  },
];

export default function KeyboardShortcutsModal({ onClose }) {
  return (
    <div
      style={BACKDROP}
      role="dialog"
      aria-modal="true"
      aria-label="میانبرهای صفحه کلید"
    >
      <div style={CARD}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12,
        }}
        >
          <div style={{
            fontSize: 15.5, fontWeight: 800, color: '#7dd3fc', lineHeight: 1.3,
          }}
          >
            میانبرهای صفحه کلید
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '6px 12px',
              background: 'rgba(51,65,85,0.6)',
              color: '#e2e8f0',
              fontFamily: "'Vazirmatn', sans-serif",
              fontSize: 12,
              fontWeight: 600,
              border: '1px solid rgba(148,163,184,0.32)',
              borderRadius: 7,
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            بستن
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {SHORTCUTS.map((s) => (
            <Row key={s.label} keys={s.keys} label={s.label} hint={s.hint} />
          ))}
        </div>
        <div style={{ fontSize: 11, color: '#64748b', lineHeight: 1.6 }}>
          همان دکمه‌های چرخش و شیب در گوشه‌ی پایینِ سمتِ چپ هم در دسترس‌اند؛ این میانبرها برای کارِ سریع‌تر هستند.
        </div>
      </div>
    </div>
  );
}
